import { makeEmptyCaption } from '@pm2/content-engine';
import { TranscriptButton } from '@pm2/element-toolbar';
import { AudioComponent } from '@pm2/media-component';
import { xml2ast, allHtmlParsers, generateJsxKey } from '@utils/ast';
import { UniversalContextMenu } from '@utils/component-framework';
import { wrapper, contextMenu } from './spec.23video.audio.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const video23AudioParsers = {
  video23audio: node => {
    const data = JSON.parse(decodeURIComponent(node.getAttribute("data") ?? "null"));
    const transcript = (() => {
      if (!data.transcript) {
        return null;
      }
      if (Array.isArray(data.transcript) && !!data.transcript.length && "nodeType" in data.transcript[0]) {
        return data.transcript;
      }
      return xml2ast(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      data.transcript?.map(it => it.text.join("<br>")).join(" "), allHtmlParsers, "text/html");
    })();
    return {
      nodeType: "video23audio",
      src: data.src,
      title: data.title,
      description: data.description,
      thumbnail: data.thumbnail,
      transcript
    };
  }
};
const video23AudioPrinters = {
  video23audio: (node, context) => {
    return /*#__PURE__*/jsxs("div", {
      className: wrapper,
      suppressHydrationWarning: true,
      children: [!!node.transcript?.length && /*#__PURE__*/jsx(UniversalContextMenu, {
        togglerClassName: contextMenu,
        layout: "solid",
        label: "\xC5bn kontekstmenuen",
        children: /*#__PURE__*/jsx(TranscriptButton, {
          nodeType: "audio-component",
          transcript: node.transcript
        }, "transcript")
      }), /*#__PURE__*/jsx(AudioComponent, {
        src: node.src,
        caption: makeEmptyCaption(),
        imageSrc: node.thumbnail?.src,
        transcript: node?.transcript ?? undefined,
        isScrambled: false
      }, generateJsxKey(context))]
    }, generateJsxKey(context));
  }
};
const video23AudioToLatexPrinters = {
  video23audio: () => {
    return null;
  }
};

export { video23AudioParsers, video23AudioPrinters, video23AudioToLatexPrinters };
//# sourceMappingURL=spec.23video.audio.js.map
